import { render } from "./MostCountries.vue?vue&type=template&id=1219fe6e&scoped=true"
import script from "./MostCountries.vue?vue&type=script&lang=js"
export * from "./MostCountries.vue?vue&type=script&lang=js"

import "./MostCountries.vue?vue&type=style&index=0&id=1219fe6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1219fe6e"]])

export default __exports__